//Template.js
///////////////////////////////
//React & Material
import React, {useState} from 'react';

//Plugins
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import ResumeDeco from '../media/resume_deco.svg'
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import Resume from'../media/Resume-Gayuru.pdf'
//Component Imports

//////////////////////////////
//Styled components
const FullHeightContainer = styled.div`
  height:100vh;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 767px) {
    margin-top:10vh;
    padding:40px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-top:10vh;
    padding:40px;
  }
`
const HeroText = styled.h1`
  text-align: left;
  font-size: 114px;
  line-height: 90%;
  /* or 147px */
  color: #36FFC1;

  @media only screen and (max-width: 767px) {
    font-size: 80px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 80px;
  }
`
const ThanksWrapper = styled(Container)`
padding: 20px;  
`
const SubtitleText = styled.h1`
  font-style: italic;
  font-size: 50px;
  /* or 64px */
  text-align: left;
  color: #FFFFFF;

  @media only screen and (max-width: 767px) {
    font-size: 30px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 30px;
  }
`
const Deco = styled.img`
  margin-top:20px;
  margin-left:30px;

  @media only screen and (max-width: 767px) {
  
    height:150px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {

    height:150px;
  }
`

const MotionDiv = styled(motion.div)`
@media only screen and (max-width: 767px) {
  margin-top:3vh;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  margin-top:3vh;
}
`

const Spacer = styled.div`
  width: 90vw;
  height: ${props => props.height}vh;
`
const SocialDeco = styled.p`
font-weight: bold;
font-size: 46px;
line-height: 104.9%;
/* or 48px */
display:inline-block;
color: #36FFC1;
opacity: 0.9;

`
const SocialText = styled.p`
font-weight: bold;
font-size: 46px;
line-height: 104.9%;
/* or 48px */
display:inline-block;
color: rgba(255, 255, 255, 0.32);
opacity: 0.9;
-webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
&:hover{
  color:#36FFC1;
}

&:hover ${SocialDeco} {
  color:white;
}
`


const SocialRow = styled(Row)`
justify-content: flex-end;
`

//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function ThanksSection(props) {


  const RenderLinks = (name, link) => {
    return (
      <SocialRow>
        <a href={link} target="_blank" rel="noopener noreferrer">
        <SocialText>
          {name}<SocialDeco>.</SocialDeco>
        </SocialText>
        </a>
      </SocialRow>
    )
  }
  return (
    <FullHeightContainer id='thanks'>
      <ThanksWrapper>
        <Row>
          <HeroText>
            Thanks
          </HeroText>
        </Row>
        <Row>
          <SubtitleText>    
            for stopping by
        </SubtitleText>
        <MotionDiv
            animate={{ rotate: 360 }}
            transition={{ duration: 15,
              loop: Infinity,
              ease: "linear",
            }}
            >  
          <a href = {Resume} target = "_blank" rel="noopener noreferrer">
          <Deco src={ResumeDeco} />
          </a>
          </MotionDiv>
        </Row>
        <Spacer height="20" />
          {RenderLinks("github", "https://github.com/gayuru")}
          {RenderLinks("linkedin", "https://www.linkedin.com/in/gayuru")}
          {RenderLinks("email", "mailto:hello@gayurug.com?subject=Let's Build Together")}
      </ThanksWrapper>
    </FullHeightContainer>
  )
}
export default ThanksSection;